import { PaymentOrderDetailsDto, PaymentRequestType, PayRequestDto } from '../types/payments.model';
import httpService from './httpService';

export async function getAuthPaymentOrderDetails(veraLinkId: string): Promise<PaymentOrderDetailsDto> {
  return httpService
    .get<PaymentOrderDetailsDto>(`/payments/order/${veraLinkId}/auth`)
    .then((res: { data: PaymentOrderDetailsDto }) => ({
      ...res.data,
      amount: res.data.amount / 100,
    }))
    .catch((err: { response?: { status: number } }) => {
      if (err.response && err.response.status === 401) {
        return Promise.reject(new Error('UNAUTHORIZED'));
      }
      if (err.response && err.response.status === 404) {
        return Promise.reject(new Error('NOT FOUND'));
      }
      console.error(err);
      return Promise.reject(err);
    });
}

export async function authPay(data: PayRequestDto): Promise<{ paymentLink: string }> {
  return httpService
    .post<{ paymentLink: string }>('/payments/pay', { ...data, origin: 'WEB' })
    .then((res: { data: { paymentLink: string } }) => res.data)
    .catch((err: { response?: { status: number } }) => {
      if (err.response && err.response.status === 401) {
        return Promise.reject(new Error('UNAUTHORIZED'));
      }
      if (err.response && err.response.status === 404) {
        return Promise.reject(new Error('NOT FOUND'));
      }
      console.error(err);
      return Promise.reject(err);
    });
}

export async function createPaymentIntent(
  data: PayRequestDto,
): Promise<{ clientSecret: string; paymentIntentId: string }> {
  return httpService
    .post<{ clientSecret: string; paymentIntentId: string }>('/payments/create-payment-intent', {
      ...data,
      origin: 'WEB',
    })
    .then((res: { data: { clientSecret: string; paymentIntentId: string } }) => res.data)
    .catch((err: { response?: { status: number } }) => {
      if (err.response && err.response.status === 401) {
        return Promise.reject(new Error('UNAUTHORIZED'));
      }
      if (err.response && err.response.status === 404) {
        return Promise.reject(new Error('NOT FOUND'));
      }
      console.error(err);
      return Promise.reject(err);
    });
}

// Create a PaymentIntent using the user-specific endpoint (same as Dashboard usage). This attaches the Stripe customer and uses card + iDEAL by default.
export async function createUserPaymentIntent(amountInCents: number): Promise<{ clientSecret: string }> {
  return httpService
    .post<{ clientSecret: string }>('/payments/intent', { amount: amountInCents })
    .then((res: { data: { clientSecret: string } }) => res.data)
    .catch((err: { response?: { status: number } }) => {
      if (err.response && err.response.status === 401) {
        return Promise.reject(new Error('UNAUTHORIZED'));
      }
      if (err.response && err.response.status === 404) {
        return Promise.reject(new Error('NOT FOUND'));
      }
      console.error(err);
      return Promise.reject(err);
    });
}

export async function changePaymentRequestType(_paymentOrderId: number, _newType: PaymentRequestType): Promise<void> {
  // TODO: implement with new API - endpoint not present in new spec
  [_paymentOrderId, _newType].forEach(() => {});
  throw new Error('TODO: implement with new API');
}

export function getInterchangeablePamentRequestTypesForType(type: PaymentRequestType): PaymentRequestType[] {
  switch (type) {
    case PaymentRequestType.ONLY_MARKABLE:
      return [];
    case PaymentRequestType.OPP:
      return [];
    case PaymentRequestType.SC_CHECKOUT_INTENT:
      throw new Error('Not implemented yet');
    case PaymentRequestType.SC_LINK:
      return [
        PaymentRequestType.SC_LINK,
        PaymentRequestType.SC_SINGLE_DIRECT_DEBIT,
        PaymentRequestType.SC_DIRECT_DEBIT,
      ];
    case PaymentRequestType.SC_SINGLE_DIRECT_DEBIT:
      return [
        PaymentRequestType.SC_LINK,
        PaymentRequestType.SC_SINGLE_DIRECT_DEBIT,
        PaymentRequestType.SC_DIRECT_DEBIT,
      ];
    case PaymentRequestType.SC_DIRECT_DEBIT:
      return [
        PaymentRequestType.SC_LINK,
        PaymentRequestType.SC_SINGLE_DIRECT_DEBIT,
        PaymentRequestType.SC_DIRECT_DEBIT,
      ];
    default:
      return [];
  }
}

export async function refundDirectDebitOrder(_paymentOrderId: number): Promise<void> {
  // TODO: implement with new API - endpoint not present in new spec
  [_paymentOrderId].forEach(() => {});
  throw new Error('TODO: implement with new API');
}

export async function cancelAuthorizedDirectDebitOrder(_paymentOrderId: number): Promise<void> {
  // TODO: implement with new API - endpoint not present in new spec
  [_paymentOrderId].forEach(() => {});
  throw new Error('TODO: implement with new API');
}

export async function markAsUnpaid(paymentOrderId: number): Promise<void> {
  return httpService
    .put(`/payments/mark-unpaid`, { paymentOrderId })
    .then(() => {})
    .catch((err: { response?: { status: number } }) => {
      if (err.response && err.response.status === 401) {
        return Promise.reject(new Error('UNAUTHORIZED'));
      }
      if (err.response && err.response.status === 404) {
        return Promise.reject(new Error('NOT FOUND'));
      }
      console.error(err);
      return Promise.reject(err);
    });
}

export async function cancelPaymentOrder(paymentOrderId: number): Promise<void> {
  return httpService
    .put(`/payments/cancel`, { paymentOrderId })
    .then(() => {})
    .catch((err: { response?: { status: number } }) => {
      if (err.response && err.response.status === 401) {
        return Promise.reject(new Error('UNAUTHORIZED'));
      }
      if (err.response && err.response.status === 404) {
        return Promise.reject(new Error('NOT FOUND'));
      }
      console.error(err);
      return Promise.reject(err);
    });
}
